import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMovements = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	fill: "#000000",
	width: "800px",
	height: "800px",
	viewBox: "0 0 32 32",
	id: "icon",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;}" }) }),
		title === undefined ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: "movement"
		}) : title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M24,20l-1.41,1.41L26.17,25H10a4,4,0,0,1,0-8H22A6,6,0,0,0,22,5H5.83L9.41,1.41,8,0,2,6l6,6,1.41-1.41L5.83,7H22a4,4,0,0,1,0,8H10a6,6,0,0,0,0,12H26.17l-3.58,3.59L24,32l6-6Z" }),
		/* @__PURE__ */ _jsx("rect", {
			id: "_Transparent_Rectangle_",
			"data-name": "<Transparent Rectangle>",
			className: "cls-1",
			width: 32,
			height: 32
		})
	]
});
const ForwardRef = forwardRef(SvgMovements);
export { ForwardRef as ReactComponent };
